import { gsap } from 'gsap';

export default function initAnimation(
    root: HTMLElement,
    container: HTMLElement,
) {
    const items = gsap.utils.toArray<HTMLElement>(
        '.label2trainingLine',
        container,
    );

    items.forEach((item, index) => {
        // console.log('init item', item, index);
        gsap.set(item, { opacity: 0, y: 20 }); // 设置初始状态
    });

    items.forEach((item, index) => {
        gsap.to(item, {
            opacity: 1, // 从透明开始
            y: 0, // 从下方 50px 的位置开始动画
            duration: 0.6,
            delay: -0.4, // 每个 item 之间的延迟
            ease: 'sine.inOut',

            scrollTrigger: {
                trigger: root, // 使用 grid 容器作为触发器
                start: 'top center', // 当 grid 容器顶部到达视口中心时开始
                end: 'top center', // 当 grid 容器底部到达视口中心时结束
                // toggleActions: 'restart', // 控制动画的开始和结束行为
                // markers: {
                //     indent: 100 * index,
                // },
                // id: `item-${index}`,
            },
        });
    });
}
